import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { TEAM_ASSIGN_API } from "../apiRoutes";

interface UseGetTeamProps {
  projectId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getTeam = async (projectId: string) => {
  return await axiosAuth.get(
    `${TEAM_ASSIGN_API}/${projectId}/role-assignments`
  );
};

const useGetTeam = ({
  projectId,
  queryParams,
}: UseGetTeamProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["roles", projectId],
    queryFn: () => getTeam(projectId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetTeam;
